<template>
    <div class="mt-5">
        Version {{version}}
    </div>
    
</template>


<script>
import packageJson from './../../../package.json';

export default {
    name: "FooterView",
    data() {
        return {
            version: packageJson.version
        }
    },
    methods: {
        openDevBar() {
            this.$emit('clickOpenDevTool')
        }
    }
}

</script>
